package org.example.site_web.pages.tests

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.css.dpi
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input

@Page
@Composable
fun TestsPage(){
    Box(
        Modifier
            .padding(48.px)
    ){
        Column {
            repeat(6) {
                Div {
                    //Text("Bonjour Pierre&Vivi x ${it}!")
                }
            }
        }
    }
   // SpanText("Bonjour Manuel&Jean!")
    Input(InputType.Text, attrs = {})
}